import axiosPublicClient from "../../../../axiosPublicClient"

// Candidate response-form state of a QA Additional Documents request (same shape as the pre-adverse context).
const documentRequestContext = async (requestKey) => {
    const result = await axiosPublicClient.post('/document-request-context', {
        requestKey,
    })
    return result.data
}

export default documentRequestContext
